<script setup lang="ts">
  import { computed } from 'vue';
  import { formatDateTime } from '../../helpers/dates';
  import { mpfMessageCardDefaults, type MpfMessageCardProps } from './MpfMessageCard.props';
  // Not scoped: this component styles slot content (the body div, its paragraphs, the
  // attachment list), which carries the PARENT's data-v id, so scoped rules never match it.
  import './MpfMessageCard.scss';

  const props = withDefaults(defineProps<MpfMessageCardProps>(), mpfMessageCardDefaults);

  // The comms endpoint still sends a pre-formatted string; only reformat real ISO values
  // so a server-formatted date is shown as-is rather than re-parsed.
  const ISO_LIKE = /^\d{4}-\d{2}-\d{2}/;

  const sentAtLabel = computed(() =>
    ISO_LIKE.test(props.sentAt) ? formatDateTime(props.sentAt) : props.sentAt,
  );
</script>

<template>
  <article class="mpf-message-card" :class="`mpf-message-card--${direction}`">
    <component
      v-if="title"
      :is="`h${props.headingLevel}`"
      class="mpf-message-card__title"
      :class="`mpf-heading-${headingLevelSize}`"
      >{{ title }}</component
    >
    <p class="mpf-message-card__meta">
      {{ sentAtPrefix }} <time :datetime="sentAt">{{ sentAtLabel }}</time>
    </p>
    <div class="mpf-message-card__body" data-private>
      <slot />
    </div>
  </article>
</template>
